import { Link } from "react-router-dom";
import styled from "styled-components";
import { RefObject } from "react";

const Nav = styled.nav`
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #e7e7e7;
  padding: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
`;

const NavContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 1240px) {
    max-width: 1240px;
  }
`;

const Logo = styled(Link)`
  font-family: "Tanker", sans-serif;
  font-size: 1.5rem;
  font-weight: normal;
  color: #373737;
  text-decoration: none;

  &:hover {
    color: #000;
    transition: all 0.2s;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavButton = styled.button`
  color: #0e0e0e;
  text-decoration: none;
  font-weight: 400;
  padding: 8px;
  border-radius: 0.375rem;
  transition: all 0.3s;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    color: #0075ff;
    background: #e6f1ff;
  }
`;

interface NavigationProps {
  aboutRef: RefObject<HTMLDivElement>;
  servicesRef: RefObject<HTMLDivElement>;
  achievementsRef: RefObject<HTMLDivElement>;
  packagesRef: RefObject<HTMLDivElement>;
  caseStudiesRef: RefObject<HTMLDivElement>;
  contactRef: RefObject<HTMLDivElement>;
}

const Navigation = ({
  aboutRef,
  servicesRef,
  achievementsRef,
  packagesRef,
  caseStudiesRef,
  contactRef,
}: NavigationProps) => {
  const scrollToSection = (ref: RefObject<HTMLDivElement>) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const navLinks = [
    {
      label: "About",
      ref: aboutRef,
    },
    {
      label: "Services",
      ref: servicesRef,
    },
    {
      label: "Achievements",
      ref: achievementsRef,
    },
    {
      label: "Packages",
      ref: packagesRef,
    },
    {
      label: "Case Studies",
      ref: caseStudiesRef,
    },
    {
      label: "Contact",
      ref: contactRef,
    },
  ];

  return (
    <Nav>
      <NavContainer>
        <Logo to="/">CHARLES BELL</Logo>
        <NavLinks>
          {navLinks.map((link) => (
            <NavButton
              key={link.label}
              onClick={() => scrollToSection(link.ref)}
            >
              {link.label}
            </NavButton>
          ))}
        </NavLinks>
      </NavContainer>
    </Nav>
  );
};

export default Navigation;
